import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DpModuleService } from 'src/app/dp-module/dp-module.service';
import { UpsiService } from 'src/app/upsi-transfer/upsi.service';

@Component({
  selector: 'app-dp-activity-log',
  templateUrl: './dp-activity-log.component.html',
  styleUrls: ['./dp-activity-log.component.scss']
})
export class DpActivityLogComponent implements OnInit {
  user_roles: any;
  role_type: any;
  user_access: boolean = false;
  dpId: any;
  //viewDpList;
  constructor(private dpService:DpModuleService, private activateRouter:ActivatedRoute, private upsiService: UpsiService, public activeModal: NgbActiveModal, private http:HttpClient) {
    this.user_roles = JSON.parse(atob(sessionStorage.getItem('sdd_access_roles')))
    this.role_type = this.user_roles.roles_name;
    if(this.user_roles.roles_name !== "Admin"){
      this.user_access = false;
    }else{
      this.user_access = true;
    }
   }

  // ngOnInit(): void {
  //     this.activateRouter.params.subscribe(data => {
  //       this.dpId = data['id']
  //     })
     
  //       if (this.dpId !== '') {
  //         this.dpService.viewActivitydp(this.dpId).subscribe(
  //           data =>{
  //           this.viewDpyList = data;
  //           console.log("this.viewDpyList", this.viewDpyList)
  //         })
    
  //         }
  // }

 

  @Input() viewDpList;



  ngOnInit() {
    // console.log("HI2", this.viewDpList);
    
  }

  closeModal(sendData) {
    this.activeModal.close(sendData);
  }

}
